// Exports
export * from './LeadResources';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Resources/index.tsx